import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 1.5H12C13.3807 1.5 14.5 2.61929 14.5 4V12C14.5 13.3807 13.3807 14.5 12 14.5H4C2.61929 14.5 1.5 13.3807 1.5 12V4C1.5 2.61929 2.61929 1.5 4 1.5Z",
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.7627 3.86711L5.2373 12.1329",
		stroke: "currentColor",
		strokeLinecap: "round"
	})]
});
export default SvgSlash;
